import { PlanBenefits } from './organisms/PlanBenefits/PlanBenefits';

import Footer from '../../components/Footer';
import WarningCookie from '../../components/WarningCookie';
import { Hero } from './organisms/Hero/Hero';
import { PlanOffers } from './organisms/PlanOffers/PlanOffers';
import Header from '../../components/Header';
import { Container, NewHomePageWrapper } from './styles';

export const NewHomePage = () => {
  return (
    <NewHomePageWrapper>
      <Header showShopLink={true} />
      <Container>
        <Hero />
        <PlanBenefits />
        <PlanOffers showButton />
        
        {/* <AppAbout /> */}
        {/* <CommunityRating /> */}
        {/* <YogaCalendar /> */}
        {/* <PlanOffers greenBackground /> */}
        {/* <Faq /> */}
        {/* <CommunityRating showButton greenBackground /> */}
      </Container>
      <Footer />
      <WarningCookie />
    </NewHomePageWrapper>
  );
};
